import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { SimpleFooterLayout } from '@user/layouts/SimpleFooterLayout';
import { FlatButton } from '@framework/ui/atoms';
import type { UserPageLocationState } from '@user/pages/UserPageLocationState';
import { classNames } from '@framework/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import BalusLogo from '@assets/balus-logo-brand-horizontal.svg';
import { Trans, useTranslation } from 'react-i18next';

type InquiryFormLinkProps = { children?: React.ReactNode };
const InquiryFormLink: React.FC<InquiryFormLinkProps> = ({ children }: InquiryFormLinkProps) => (
  <a
    href="https://balus-help.levii.co.jp/hc/ja/requests/new"
    target="_blank"
    rel="noreferrer"
    className="text-sm text-blue-700 hover:underline"
  >
    {children} <FontAwesomeIcon icon={faExternalLinkAlt} />
  </a>
);

export const AccountConnectedPage: React.FC<unknown> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleMoveHome = useCallback(() => navigate('/'), [navigate]);

  const location = useLocation() as { state?: UserPageLocationState };
  const { message, isSuccess } = location.state?.accountConnectedPage || {
    message: t('auth.accountConnected.defaultError'),
    isSuccess: false,
  };

  return (
    <SimpleFooterLayout>
      <div className="mx-auto flex flex-col items-center px-4 pb-8 pt-16 md:container">
        <img src={BalusLogo} className="w-64" />
        <div className="py-8 text-3xl font-bold">{t('auth.accountConnected.title')}</div>

        <div className="rounded-lg border border-gray-500 p-8" style={{ width: '600px' }}>
          <div className={classNames(isSuccess ? '' : 'text-red-700')}>{message}</div>
          <div className="py-8 text-center">
            <FlatButton className="px-16" color="brand" onClick={handleMoveHome}>
              {t('auth.accountConnected.goHome')}
            </FlatButton>
          </div>

          {!isSuccess && (
            <div className="text-sm">
              <Trans i18nKey="auth.accountConnected.failure" components={{ inquiryFormLink: <InquiryFormLink /> }} />
            </div>
          )}
        </div>
      </div>
    </SimpleFooterLayout>
  );
};
